import { PayloadAction } from '@reduxjs/toolkit';

import { LivePreviewState } from '../types';

const setSelectedSceneReducer = (state: LivePreviewState, action: PayloadAction<string>) => {
  state.selectedSceneName = action.payload;
};

export default setSelectedSceneReducer;
